import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { FeedbackService, Feedback } from '../../services/feedback.service';
import { TranslateModule } from '@ngx-translate/core';

interface NPSAvailability {
  data_fim: string;
  data_inicio: string;
  descricao_periodo: string;
  disponivel: boolean;
  periodo: string;
  success: boolean;
}

@Component({
  selector: 'app-rating-feedback',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatDialogModule,
    TranslateModule
  ],
  templateUrl: './rating-feedback.component.html',
  styleUrls: ['./rating-feedback.component.css']
})
export class RatingFeedbackComponent implements OnInit {
  showRating = false;
  showFeedback = false;
  rating: number | null = null;
  feedback: string = '';
  ratings: number[] = Array.from({length: 10}, (_, i) => i + 1);
  availability: NPSAvailability | null = null;
  isSubmitting = false;

  constructor(private feedbackService: FeedbackService) { }

  ngOnInit(): void {
    this.checkNPSAvailability();
  }

  checkNPSAvailability(): void {
    this.feedbackService.checkAvailability().subscribe({
      next: (response: NPSAvailability) => {
        this.availability = response;
        
        if (response.disponivel) {
          setTimeout(() => {
            this.showRating = true;
          }, 5000);
        }
      },
      error: (error) => {
        console.error('Erro na verificação de disponibilidade');
      }
    });
  }

  selectRating(value: number): void {
    this.rating = value;
    this.showFeedback = true;
  }

  private sanitizeFeedback(feedback: string): string {
    return feedback.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, '').trim();
  }

  private validateRating(rating: any): number | null {
    const num = Number(rating);
    return Number.isInteger(num) && num >= 0 && num <= 10 ? num : null;
  }

  submitFeedback(): void {
    if (this.isSubmitting) return;

    const validatedRating = this.validateRating(this.rating);
    if (!validatedRating) {
      console.error('Rating inválido');
      return;
    }

    const sanitizedFeedback = this.sanitizeFeedback(this.feedback);
    
    const feedbackData: Feedback = {
      rating: validatedRating,
      timestamp: new Date().toISOString()
    };

    if (sanitizedFeedback) {
      feedbackData.feedback = sanitizedFeedback;
    }

    this.isSubmitting = true;
    console.log('isSubmitting definido como true');

    // Força um delay mínimo para mostrar o estado "enviando"
    setTimeout(() => {
      this.feedbackService.submitFeedback(feedbackData).subscribe({
        next: (response) => {
          console.log('Feedback enviado com sucesso');
          // Aguarda um pouco para mostrar o estado "enviando" antes de fechar
          setTimeout(() => {
            this.isSubmitting = false;
            this.closeRating();
          }, 1000);
        },
        error: (error) => {
          console.error('Erro ao enviar feedback');
          this.isSubmitting = false;
        }
      });
    }, 500); // Delay de 500ms para garantir que o estado seja mostrado
  }

  closeRating(): void {
    this.showRating = false;
    this.showFeedback = false;
    this.rating = null;
    this.feedback = '';
  }
}

